<template>
  <div class="home-container">
    <!-- tab和广告区 -->
    <TabAndAd />
    <!-- 公告相关区 -->
    <NoticeArea :announcements="announcements" :noticeType="noticeType" @region-change="handleRegionChange"
      @property-change="handlePropertyChange" @noticeType="handleNoticeType" />
    <!-- 临时调试入口：CA 控件文件级加解密测试 -->
    <!-- <el-button class="ca-file-test-entry" type="warning" size="small"
      icon="el-icon-document" @click="$router.push('/ca-file-test')">
      CA 文件测试
    </el-button> -->
  </div>
</template>

<style scoped>
.ca-file-test-entry {
  position: fixed;
  right: 24px;
  bottom: 80px;
  z-index: 999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>

<script>
import TabAndAd from '@/components/system/home/tabAndAd.vue'
import NoticeArea from '@/components/system/home/noticeArea.vue'
import { getNoticeList } from '@/api/home/api'
export default {
  components: {
    TabAndAd,
    NoticeArea,
  },
  data() {
    return {
      announcements: [],
      provinceCode: '',
      procurementType: '1',
      noticeType: 1
    }
  },

  computed: {
    channelCode() {
      return this.$channelMaterial.getChannelCode()
    },
  },
  mounted() {
    window.addEventListener('popstate', this.handlePopState);
    this.getNoticeList()
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState);
  },

  methods: {
    handlePopState(event) {
      event.preventDefault();
      event.stopPropagation();
      this.$router.push('/');
    },
    handleRegionChange(value) {
      this.provinceCode = value;
      this.getNoticeList();
    },
    handlePropertyChange(value) {
      this.procurementType = value;
      this.getNoticeList();
    },
    handleNoticeType(value) {
      this.noticeType = value;
      this.getNoticeList();
    },
    getNoticeList() {
      this.announcements = []
      let data = {
        pageIndex: 1,
        pageSize: 10,
        procurementType: this.procurementType,
        provinceCode: this.provinceCode,
        noticeType: this.noticeType,
        channelCode: this.channelCode
      }
      getNoticeList(data).then(res => {
        if (res.code === 200) {
          console.log('返回数据:', JSON.stringify(res.data))
          this.announcements = res.data.records || []
          this.$nextTick(() => {
            console.log('announcements 已更新:', this.announcements.length)
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    }

  }
}
</script>

<style>
.home-container {
  width: 100%;

  min-height: 100%;
  padding: 0px 2.3%;
  background: linear-gradient(to right, #F7F8F9, #F1F3F5);
  padding-bottom: 50px;
}
</style>